import {Component, DoCheck, ElementRef, Input, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {FeatureFlagsService} from "../../services/feature-flag/feature-flags.service";

@Component({
  selector: 'sb-feature-on',
  templateUrl: './feature-on.component.html',
  styleUrls: ['./feature-on.component.scss']
})
export class FeatureOnComponent {

  @Input()
  public featureOn: string;

  constructor() { }
}
